var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew318({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.81,12.07V3.93H6.14L7.72,9.69,8,10.9,8.4,9.59,10,3.93h1.19v8.14h-.85V5.26L8.39,12.07H7.6L5.66,5.14v6.93Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1.5,
    y: 1.5,
    width: 13,
    height: 13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew318);
export default __webpack_public_path__ + "static/media/Symbolpack_New_318.202298ac32bbe947a6a22a030519ba62.svg";
export { ForwardRef as ReactComponent };